import { render } from "./ApprovePayments.vue?vue&type=template&id=2d348e9c"
import script from "./ApprovePayments.vue?vue&type=script&lang=js"
export * from "./ApprovePayments.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__